import request from '@/utils/request'

//获取验证图片
export function reqGet(data) {
    return request({
        url: '/captcha/get',
        method: 'post',
        data
    })
}

//滑动或者点选验证
export function reqCheck(data) {
    return request({
        url: '/captcha/check',
        method: 'post',
        data
    })
}

///用户中心

//上传身份证
export function uploadCard(data) {
    return request({
        url: '/web/user/shenfenzhzeng',
        method: 'post',
        data
    })
}
//修改密码
export function restPass(data) {
    return request({
        url: '/web/user/restPass',
        method: 'post',
        data
    })
}

